import { IOptionLists } from "../../components/filter-chips/filter-chips.props";
import { reduceValues } from "../filters.functions";

export const paramsToValues = (params: any, options: IOptionLists) => {
  const values = reduceValues(params, options);

  return {
    dateFrom: "",
    dateTo: "",
    flyerOwner: null,
    ...values,
  };
};
